export const commonConstant = {
  ADDITIONAL_TRIALDAYS: 13,
};
